import { render, staticRenderFns } from "./CategoryContainer.vue?vue&type=template&id=3f091a32&scoped=true"
import script from "./CategoryContainer.vue?vue&type=script&lang=ts"
export * from "./CategoryContainer.vue?vue&type=script&lang=ts"
import style0 from "./CategoryContainer.vue?vue&type=style&index=0&id=3f091a32&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f091a32",
  null
  
)

export default component.exports